export default "__VITE_ASSET__CjGmTu9G__"